module.exports = __webpack_public_path__ + "static/oyabola-da9ad83474e3293c8562f9c9cded2dc6.png";